var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.439,34.222c-1.104,0-2,0.896-2,2v1.104h-2.062v-8.595c0-4.889-3.978-8.866-8.866-8.866h-1.023 c-4.889,0-8.866,3.977-8.866,8.866v8.595h-2.062v-1.104c0-1.104-0.896-2-2-2s-2,0.896-2,2v13.459 c0,7.834,5.87,14.309,13.439,15.295v7.157h-9.263c-1.104,0-2,0.896-2,2s0.896,2,2,2h22.527c1.104,0,2-0.896,2-2s-0.896-2-2-2H50 v-7.157c7.57-0.986,13.439-7.46,13.439-15.295V36.222C63.439,35.118,62.544,34.222,61.439,34.222z M42.623,41.326h10.755v8.595 c0,2.683-2.183,4.865-4.866,4.865h-1.023c-2.683,0-4.866-2.183-4.866-4.865V41.326z M47.488,23.866h1.023 c2.684,0,4.866,2.183,4.866,4.866v8.595H42.623v-8.595C42.623,26.048,44.805,23.866,47.488,23.866z M48,61.121 c-6.308,0-11.439-5.132-11.439-11.439v-8.355h2.062v8.595c0,4.889,3.977,8.865,8.866,8.865h1.023c4.889,0,8.866-3.977,8.866-8.865 v-8.595h2.062v8.355C59.439,55.989,54.308,61.121,48,61.121z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.c8457ff5a5d0f494cd3b70546ff0f99a.svg";
export { ForwardRef as ReactComponent };